import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { CheckCircle, Package } from 'lucide-react';
import { orderAPI } from '../../services/api';

export const OrderSuccessPage = () => {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    if (orderId) orderAPI.getOne(orderId).then(({ data }) => setOrder(data)).catch(() => {});
  }, [orderId]);

  return (
    <div style={{ paddingTop: '72px', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ maxWidth: '540px', width: '100%', padding: '24px', textAlign: 'center' }}>
        <div style={{ width: '80px', height: '80px', borderRadius: '50%', background: 'rgba(201,168,76,0.1)', border: '1px solid var(--gold)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 32px' }}>
          <CheckCircle size={40} color="var(--gold)" />
        </div>
        <h1 style={{ fontFamily: 'var(--font-display)', fontSize: '40px', fontWeight: 400, marginBottom: '12px' }}>Order Confirmed</h1>
        <p style={{ color: 'var(--white-dim)', fontSize: '14px', lineHeight: 1.8, marginBottom: '32px' }}>
          Thank you for your purchase. Your fragrance is being prepared with care.
        </p>

        {order && (
          <div style={{ background: 'var(--dark-2)', border: '1px solid var(--border)', padding: '24px', marginBottom: '32px', textAlign: 'left' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '16px' }}>
              <span style={{ fontSize: '11px', color: 'var(--white-dim)', letterSpacing: '0.1em' }}>ORDER NUMBER</span>
              <span style={{ fontSize: '13px', color: 'var(--gold)', fontWeight: 600 }}>{order.orderNumber}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '16px' }}>
              <span style={{ fontSize: '11px', color: 'var(--white-dim)', letterSpacing: '0.1em' }}>TOTAL</span>
              <span style={{ fontFamily: 'var(--font-display)', fontSize: '20px' }}>${order.totalPrice}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span style={{ fontSize: '11px', color: 'var(--white-dim)', letterSpacing: '0.1em' }}>STATUS</span>
              <span style={{ fontSize: '12px', color: 'var(--gold)', letterSpacing: '0.1em', textTransform: 'uppercase' }}>{order.orderStatus}</span>
            </div>
          </div>
        )}

        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
          <Link to="/profile" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', background: 'var(--gold)', color: 'var(--black)', padding: '12px 24px', fontSize: '11px', fontWeight: 700, letterSpacing: '0.15em' }}>
            <Package size={14} /> TRACK ORDER
          </Link>
          <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', border: '1px solid var(--border)', color: 'var(--white)', padding: '12px 24px', fontSize: '11px', letterSpacing: '0.15em' }}>
            CONTINUE SHOPPING
          </Link>
        </div>
      </div>
    </div>
  );
};

export default OrderSuccessPage;
